import { type MCPServerInfo } from '../../types';

const SupernovaServer: MCPServerInfo = {
  serverId: 'SUPERNOVA',
  name: 'Supernova.io',
  slug: 'supernova',
  description: 'Supernova MCP server with dynamic dataset endpoint.',
  source: {
    sourceType: 'DYNAMIC_REMOTE_URL',
    mcpServerUrl: 'https://mcp.supernova.io/mcp/ds/{designSystemId}'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: ['designSystemId'],
    properties: {
      designSystemId: {
        type: 'string',
        description:
          'Supernova design system ID from app.supernova.io URL (e.g., 60216).',
        sensitive: false,
        isUrlParameter: true
      }
    }
  },
  installConfig: {
    required: ['designSystemId'],
    properties: {
      designSystemId: {
        type: 'string',
        description:
          'Supernova design system ID from app.supernova.io URL (e.g., 60216).',
        sensitive: false,
        isUrlParameter: true
      }
    }
  }
};

export default SupernovaServer;
